var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('p',[_vm._v(_vm._s(_vm.greeting))]),_c('p',[_vm._v(_vm._s(_vm.flaskGreeting))])])
}
var staticRenderFns = []

export { render, staticRenderFns }